// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

const OverviewDetailItem = ({ title, value }) => {
  const renderedValue = () => {
    if (value) {
      return (<span className='value'>{value}</span>)
    } else {
      return (<span className='empty value'>Not available</span>)
    }
  }

  return (
    <div className='pro-padded padding-3 supplier-detail-item'>
      <h3 className='pro-text-xs bold color-pro-steel-grey-500'>{title}</h3>
      {renderedValue()}
    </div>
  )
}

OverviewDetailItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

OverviewDetailItem.defaultProps = {
  value: null
}

export default OverviewDetailItem
